import type { TileFacts, TileRow } from "@kundeninfo/api-client";
import type { ListenkachelKennzahl } from "@kundeninfo/ui/me-design";
import { FACT_TEXT, MARKER_TEXT, levelWord, shortDate } from "./texts.js";
import type { LevelArt, LevelWord } from "./texts.js";
import type { TileContext, TileRowView } from "./tileCatalog.js";

/* Die Bausteine, aus denen jede Kachel (Belege, Wichtiges, Tickets, Notizen, Dateien, Konzern) Zeilen und Kennzahlen setzt. */

/** Der Tag der Zeile kurz („03.11.“, im anderen Jahr mit Jahr); ohne Datum `null`. */
export const dayText = (r: TileRow, ctx: TileContext): string | null =>
  (r.date === null ? null : shortDate(r.date, ctx.today));

/** Das Wort zum Kennzeichen der Zeile; ohne Kennzeichen leer. */
export const markerText = (r: TileRow): string => (r.marker === null ? "" : MARKER_TEXT[r.marker]);

/** Der Zustand der Zeile als Wort neben der Farbe, je nachdem, wovon die Rede ist. */
export const levelOf = (art: LevelArt, r: TileRow, ctx: TileContext): LevelWord =>
  levelWord(r.level, r.date, ctx.today, art);

/** Die gemeinsame Gestalt: Kennung aus `reference`, Zusatz rechts (`extra`), zweite Zeile aus den Stücken, die da sind. */
export function rowView(r: TileRow, text: string, extra: string | null, below: readonly string[], state: LevelWord): TileRowView {
  const second = below.filter((part) => part !== "").join(" · ");
  return { text, ...(r.reference === null ? {} : { kennung: r.reference }), ...(extra === null ? {} : { zusatz: extra }),
    ...(second === "" ? {} : { unter: second }), ...state };
}

/** Eine Zahl, die erst ab 1 einen Zustand trägt; bei 0 bleibt sie ohne stehen, damit das Layout nicht kippt. */
export function flagged(label: string, n: number | undefined, statusArt: "fehler" | "warnung"): ListenkachelKennzahl {
  const value = n ?? 0;
  return { beschriftung: label, wert: value, ...(value > 0 ? { statusArt, status: label } : {}) };
}

/** Der nächste Termin einer Kachel (Frist, Wiedervorlage) mit seinem Zustand, ohne Termin „–“. */
export const nextDateFact = (label: string, art: LevelArt, f: TileFacts, ctx: TileContext): ListenkachelKennzahl =>
  ({ beschriftung: label, wert: f.nextDate ? shortDate(f.nextDate, ctx.today) : FACT_TEXT.none,
    ...levelWord(f.nextDateLevel ?? null, null, ctx.today, art) });
